export const LOADING_FORM_TYPE = "LOADING_FORM_TYPE";
export const SAVE_LOADING_FORM_TYPE = "SAVE_LOADING_FORM_TYPE";
export const GET_FORM_TYPE = "GET_FORM_TYPE";
export const FORM_FAIL = "FORM_FAIL";
export const FORM_TYPE_FAIL = "FORM_TYPE_FAIL";
export const LOADING_FORM_TYPE_BY_ID = "LOADING_FORM_TYPE_BY_ID";
export const GET_FORM_TYPE_BY_ID = "GET_FORM_TYPE_BY_ID";

